import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-change-validation',
  templateUrl: './change-validation.component.html',
  styleUrls: ['./change-validation.component.scss']
})
export class ChangeValidationComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private sharedService: SharedService) {

  }
  submit() {
    this.sharedService.$customerChanged.next(this.data.customer)
  }
}

